// Functionality revolving around Web3 ID credentials.
export * from '../web3-id/index.js';
